module.exports = ".modal {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n.modal-dialog {\n    margin-top: 30vh;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirm-modal/confirm-modal.component.css
// module id = ./src/app/shared/components/confirm-modal/confirm-modal.component.css
// module chunks = main